import { gql } from '@apollo/client';
import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import DataTableCompact from '../../components/DataTableCompact';
import Select from 'react-select';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import '../../../assets/scss/projectTable.scss';
import Filter from '../../components/filter';
import { ReactComponent as Back } from '../../../assets/svg/arrow-back2.svg';
import { ReactComponent as Download } from '../../../assets/svg/download-btn.svg';
import { ReactComponent as Info } from '../../../assets/svg/info-svg.svg';
import { ReactComponent as Rank } from '../../../assets/svg/rank-icon.svg';
import { ReactComponent as Edit } from '../../../assets/svg/edit-2.svg';
import { ReactComponent as Delete } from '../../../assets/svg/delete-icon.svg';
import _ from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	ReferenceLine,
	Tooltip,
	Legend,
	BarChart,
	Bar,
	Line,
	Label,
} from 'recharts';
import LoadingBar from '../../components/global/loadingBar';
import Modal from '../../components/modals';
import UploadLogoForm from '../../components/modals/workspace/logo';
import Dropzone from 'react-dropzone';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import AssignAsset from '../../components/modals/projects/assignAsset';
import { TENANT_USER_LOGIN_SIGNUP_API } from '../../../controllers/actionTypes';
import EditAttendance from '../../components/attendance/editAttendance';
import { formatEmpAttHours } from '../../../utils/common';
var validator = require('validator');
const getEmployeeAttendanceDetailsList = gql`
	query EmployeeAttendanceList(
		$employeeAttendanceListId: ID!
		$filters: EmpAttendanceListFiltersInput
	) {
		employeeAttendanceList(id: $employeeAttendanceListId, filters: $filters) {
			_id
			fullName
			designation
			department
			personalPhoneNumber
			personalEmail
			officePhoneNumber
			officeEmail
			workspaceId
			dp_signed_url
			attedanceList {
				data {
					_id
					date
					logins {
						timestamp
					}
					logouts {
						timestamp
					}
					status
					totalHours
					divisionId
					notes {
						_id
						message
						createdBy {
							id
							name
						}
						createdAt
					}
					updatedBy
					updatedAt
				}
				totalPages
				totalDocs
				limit
				currentPage
				hasNextPage
				hasPrevPage
				prevPage
				nextPage
			}
		}
	}
`;
class EmployeeAttendanceDetails extends ProjectsGraphQl {
	constructor() {
		super();
		this.calRef = React.createRef(null);
		const currentYear = moment().year();
		const currentMonth = moment().month();
		const startDate = moment().set({ year: currentYear, month: currentMonth });

		const monthOptions = [];
		let currentDate = startDate.clone();

		while (currentDate.isSameOrAfter(moment('2022-01-01'))) {
			monthOptions.push({
				key: currentDate.format('YYYYMM'),
				name: currentDate.format('MMM YYYY'),
			});
			currentDate.subtract(1, 'month');
		}
		this.state = {
			employeeDetails: {},
			employeeAttendanceDetails: {},
			hoveredRows: Array(8).fill(false),
			hoveredRows2: Array(8).fill(false),
			empId: null,
			imageSrc: null,
			monthOptions,
			monthActiveFilter: moment().startOf('month').format('YYYYMM'),
			showUploadLogoModal: false,
			croppedFile: null,
			showEmployeeDetails: true,
			showEmployment: false,
			showContact: false,
			showProductivity: false,
			assets: [],
			employeeExpenseDetails: null,

			showBank: false,
			userProductivityDetails: null,
			message: '',
			employeeId: '',
			employeeId2: '',
			workspaceOptions: [],
			limit: 20,
			page: 1,
			isLoading: true,
			currentViewPage: 1,

			employeeType: '',
			genderType: '',
			designations: [],
			departments: [],
			showAssetModal: false,
			employeeType: null,
			selectedBloodGroup: '',

			branchesOptions: [],
			selectedBranch: '',
			selectedDepartment: '',
			selectedDesignation: '',
			branchId: '',
			selectedDob: '',
			selectedJoiningDate: '',
			fnError: false,
			lnError: false,
			adError: false,
			panerror: false,
			curcityEr: false,
			curcountryEr: false,
			curDistrictEr: false,
			curPcEr: false,
			curStateEr: false,
			curStreetEr: false,
			percityEr: false,
			percountryEr: false,
			perDistrictEr: false,
			isemployeeloading: true,
			perPcEr: false,
			perStateEr: false,
			perStreetEr: false,
			emergencyNameError: false,
			bankifscEr: false,
			bankAccHolErr: false,
			bankAccNumberError: false,
			bankBranchError: false,
			bankNameError: false,
			selectedMonth: new Date(),
			selectedBrand: '',
			brandString: '',
			branchIdString: '',
			statusOptions: [
				{ value: 'ACTIVE', label: 'Active' },
				{ value: 'TERMINATED', label: 'Terminated' },
				{ value: 'ON_HOLD', label: 'On Hold' },
			],
			showEditAttendanceModal: false,
			modalData: {},
			columns: [
				// { title: 'FLAG' },

				{ title: 'Day' },
				{ title: 'Attendance State' },
				{ title: 'Clock In' },
				{ title: 'Clock Out' },
				{ title: 'Workin Hours' },
				// { title: 'Overtime' },
				// { title: 'Fine' },
			],
		};
	}
	componentDidMount = () => {
		let json = {};

		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (
					subString[0] &&
					(subString[0] === 'page' ||
						subString[0] === 'limit' ||
						subString[0] === 'startDate' ||
						subString[0] === 'endDate')
				) {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					if (subString[0] === 'page') {
						this.setState({
							currentViewPage: parseInt(subString[1]),
						});
					} else {
						this.setState({
							[subString[0]]: parseInt(subString[1]),
						});
					}
				}
				if (subString[0] && subString[0] === 'startDate') {
					this.setState({
						selectedMonth: moment(subString[1], 'YYYYMMDD').toDate(),
					});
				}

				count++;
			}
			json = {
				...json,
				employeeAttendanceListId: this.props.params.attendanceid,
				filters: {
					...json.filters,
				},
			};
		} else {
			json = {
				employeeAttendanceListId: this.props.params.attendanceid,
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
					startDate: parseInt(
						moment(this.state.selectedMonth).startOf('month').format('YYYYMMDD'),
					),
					endDate: parseInt(
						moment(this.state.selectedMonth).endOf('month').format('YYYYMMDD'),
					),
				},
			};
		}

		this.getEmployeeAttendanceDetailsList(getEmployeeAttendanceDetailsList, json);
	};
	onClickNextPage = async () => {
		if (
			this.state.currentViewPage <
			this.state.employeeAttendanceDetails?.attedanceList?.totalPages
		) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreAttDetailsList();
				},
			);
		}
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreAttDetailsList();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreAttDetailsList();
			},
		);
	};
	fetchMoreAttDetailsList = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

		// if (this.state.scopeActiveFilter.length !== 0)
		queryString = `${queryString}&startDate=${moment(this.state.selectedMonth)
			.startOf('month')
			.format('YYYYMMDD')}&endDate=${moment(this.state.selectedMonth)
			.endOf('month')
			.format('YYYYMMDD')}`;
		// if (this.state.workspaceActiveFilter.length !== 0)
		// 	queryString = `${queryString}&tenantId=${this.state.workspaceActiveFilter.toString()}`;

		// if (this.state.activeFlag.length !== 0)
		// 	queryString = `${queryString}&activeFlag=${this.state.activeFlag.toString()}`;
		this.props.navigate(
			`/${this.props.params.vendorID}/attendance/${this.props.params.attendanceid}/${queryString}`,
		);

		let filters = {
			employeeAttendanceListId: this.props.params.attendanceid,
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
				startDate: parseInt(
					moment(this.state.selectedMonth).startOf('month').format('YYYYMMDD'),
				),
				endDate: parseInt(
					moment(this.state.selectedMonth).endOf('month').format('YYYYMMDD'),
				),
			},
		};

		// if (this.state.scopeActiveFilter.length !== 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			scope: this.state.scopeActiveFilter,
		// 		},
		// 	};
		// 	json = {
		// 		...json,
		// 		filters: {
		// 			...json.filters,
		// 			scope: this.state.scopeActiveFilter,
		// 		},
		// 	};
		// }
		// if (this.state.workspaceActiveFilter.length !== 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			tenantId: this.state.workspaceActiveFilter,
		// 		},
		// 	};
		// 	json = {
		// 		...json,
		// 		filters: {
		// 			...json.filters,
		// 			tenantId: this.state.workspaceActiveFilter,
		// 		},
		// 	};
		// }

		// if (this.state.activeFlag !== '' && this.state.activeFlag.length > 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			statusFilters: this.state.activeFlag,
		// 		},
		// 	};
		// }
		this.setState({
			isLoading: true,
		});
		// console.log('debugging filters for task flags--->', json);
		// this.getTaskFlags(getTaskFlags, json);
		await this.getEmployeeAttendanceDetailsList(getEmployeeAttendanceDetailsList, filters);
		// await this.getEmployeesAttendanceCount(getEmployeesAttendanceCount, json);
	};
	handleMouseEnter = (index) => {
		const newHoveredRows = [...this.state.hoveredRows];
		newHoveredRows[index] = true;
		this.setState({ hoveredRows: newHoveredRows });
	};

	handleMouseLeave = (index) => {
		const newHoveredRows = [...this.state.hoveredRows];
		newHoveredRows[index] = false;
		this.setState({ hoveredRows: newHoveredRows });
	};
	handleMouseEnter2 = (index) => {
		const newHoveredRows = [...this.state.hoveredRows2];
		newHoveredRows[index] = true;
		this.setState({ hoveredRows2: newHoveredRows });
	};
	getttinLoginLogoutString = (arr) => {
		var str = '';
		for (let i = 0; i < arr.length; i++) {
			str += arr[i]?.timestamp;
			if (i < arr.length - 1) {
				str += ', ';
			}
		}
		return str;
	};
	handleMouseLeave2 = (index) => {
		const newHoveredRows = [...this.state.hoveredRows2];
		newHoveredRows[index] = false;
		this.setState({ hoveredRows2: newHoveredRows });
	};
	showEditAttendanceModal = (date, clockins, clockouts, attendanceState, notes, id) => {
		this.setState({
			showEditAttendanceModal: !this.state.showEditAttendanceModal,
			modalData: {
				date: date,
				clockins: clockins,
				clockouts: clockouts,
				attendanceState: attendanceState,
				notes: notes,
				id: id,
			},
		});
	};
	render() {
		console.log('logging selected month', this.state.selectedMonth);
		return (
			<div>
				<div className="layout-wrapper">
					{this.state.isLoading ? (
						<LoadingBar />
					) : (
						<div className="container">
							<div
								className="searchContainer"
								style={{
									padding: '28px 24px',
								}}
							>
								<a
									className="title"
									style={{
										color: '#B0B0B0',
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<Back
										style={{
											cursor: 'pointer',
											height: '24px',
											width: '24px',
										}}
										onClick={() => {
											this.props.navigate(
												`/${this.props.params.vendorID}/attendance`,
											);
										}}
									/>
									<span
										style={{
											marginLeft: '16px',
											fontSize: '24px',
											fontWeight: '500',
											color: '#DBDBDB',
											fontFamily: 'Inter',
											fontStyle: 'normal',
											textDecoration: 'none',
										}}
									>
										{this.state.employeeAttendanceDetails.fullName}
									</span>
								</a>
								<div className="datePicker2">
									<div className="dp-container">
										<DatePicker
											style={{
												marginLeft: '150px',
											}}
											ref={this.calRef}
											selected={this.state.selectedMonth}
											onChange={(date) => {
												this.setState(
													{
														selectedMonth: date,
													},
													() => {
														this.fetchMoreAttDetailsList();
													},
												);
												console.log('checking selected month', date);
											}}
											showMonthYearPicker
											dateFormat="MM/yyyy"
										/>
										<div
											className=""
											style={{
												marginLeft: '80px',
											}}
										>
											<button
												style={{
													marginLeft: '10px',
													cursor: 'pointer',
													backgroundColor: '#F5F5F5',
													borderRadius: '4px',
													border: 'none',
													padding: '6px 8px',
												}}
												onClick={() => {
													this.calRef.current.setOpen(false);
													this.setState({
														selectedMonth: new Date(),
													});
												}}
											>
												Reset
											</button>
											<button
												style={{
													marginLeft: '10px',
													cursor: 'pointer',
													backgroundColor: '#2153CC',
													borderRadius: '4px',
													color: 'white',
													border: 'none',
													padding: '6px 8px',
												}}
												onClick={() => {
													this.calRef.current.setOpen(false);
													// Handle apply logic here
													console.log(
														'Selected month:',
														this.state.selectedMonth,
													);
												}}
											>
												Apply
											</button>
										</div>
									</div>
								</div>
								{/* <div
									style={{
										padding: '10px 16px',
										borderRadius: '40px',
										background: '#6055EC',
										display: 'flex',
										alignItems: 'center',
										gap: '6px',
									}}
								>
									<p
										style={{
											color: '#EFEFEF',
											fontFamily: 'Inter',
											fontSize: '13px',
											fontStyle: 'normal',
											fontWeight: 500,
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										Download Report
									</p>
									<Download />
								</div> */}
							</div>
							<div
								style={{
									position: 'relative',
									top: '100px',
									width: '100%',
									left: '0px',
									padding: '0px 24px',
								}}
							>
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'space-between',
									}}
								>
									<div
										style={{
											width: '25%',
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											marginTop: '10px',
										}}
									>
										<img
											src={
												this.state.employeeAttendanceDetails?.dp_signed_url
											}
											alt=""
											style={{
												width: '100%',
												height: '312px',
											}}
										/>

										<div
											className="emp-det-style"
											style={{
												width: '100%',
												backgroundColor: 'rgba(42, 42, 42, 0.5)',
												padding: '30px 13px',
												display: 'flex',
												flexDirection: 'column',

												// justifyContent: 'space-between',
												gap: '20px',
												// color: 'white',
											}}
										>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Display Name</p>
												<p className="emp-det-row-second">
													{this.state.employeeAttendanceDetails.fullName}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Designation</p>
												<p className="emp-det-row-second">
													{
														this.state.employeeAttendanceDetails
															.designation
													}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">
													Office Phone and Email
												</p>
												<p
													className="emp-det-row-second"
													style={{
														marginBottom: '5px',
													}}
												>
													{
														this.state.employeeAttendanceDetails
															?.officePhoneNumber
													}
												</p>
												<p
													className="emp-det-row-second"
													style={{
														textTransform: 'none',
													}}
												>
													{
														this.state.employeeAttendanceDetails
															?.officeEmail
													}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">
													Personal Phone and Email
												</p>
												<p
													className="emp-det-row-second"
													style={{
														marginBottom: '5px',
													}}
												>
													{
														this.state.employeeAttendanceDetails
															?.personalPhoneNumber
													}
												</p>
												<p
													className="emp-det-row-second"
													style={{
														textTransform: 'none',
													}}
												>
													{
														this.state.employeeAttendanceDetails
															?.personalEmail
													}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Department</p>
												<p className="emp-det-row-second">
													{
														this.state.employeeAttendanceDetails
															.department
													}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Brand</p>
												<p className="emp-det-row-second">
													{
														this.state.employeeAttendanceDetails
															.workspaceId
													}
												</p>
											</div>
										</div>
									</div>
									<div
										style={{
											width: 'calc(75% - 40px)',
										}}
									>
										<DataTableCompact
											attendanceDetails={true}
											tableHeaderLeftPad={35}
											isLoading={this.state.isLoading}
											tableHeader={`SHOOTS`}
											columns={this.state.columns}
											// isPageLoading={this.state.isPageLoading}
											limit={this.state.limit}
											totalPages={
												this.state.employeeAttendanceDetails?.attedanceList
													?.totalPages
											}
											currentViewPage={this.state.currentViewPage}
											lengthOfList={
												this.state.employeeAttendanceDetails?.attedanceList
													?.totalDocs
											}
											onClickNextPage={this.onClickNextPage}
											onClickPreviousPage={this.onClickPreviousPage}
											dataList={
												this.state.employeeAttendanceDetails?.attedanceList
													?.data
											}
											goToPage={(e) => this.handleGoToPage(e)}
											module={'project'}
											searchQuery={''}
											mainFilter={''}
										>
											{this.state.employeeAttendanceDetails?.attedanceList
												?.data &&
												this.state.employeeAttendanceDetails?.attedanceList?.data.map(
													(empAtt, idx) => {
														return (
															<tr
																onClick={() => {
																	// alert(`${asset.serialNumber}`);
																	if (
																		empAtt?.status !==
																			'present' &&
																		(moment().format(
																			'MMYYYY',
																		) ==
																			moment(
																				empAtt?.date.toString(),
																				'YYYYMMDD',
																			).format('MMYYYY') ||
																			moment()
																				.format('MMYYYY')
																				.subtract(
																					1,
																					'months',
																				) ==
																				moment(
																					empAtt?.date.toString(),
																					'YYYYMMDD',
																				).format('MMYYYY'))
																	) {
																		this.showEditAttendanceModal(
																			moment(
																				empAtt?.date.toString(),
																				'YYYYMMDD',
																			).format(
																				'DD MMMM YYYY',
																			),
																			empAtt?.logins
																				? this.getttinLoginLogoutString(
																						empAtt?.logins,
																				  )
																				: '-',
																			empAtt?.logouts
																				? this.getttinLoginLogoutString(
																						empAtt?.logouts,
																				  )
																				: '-',
																			empAtt?.status ==
																				'present'
																				? {
																						value: 'present',
																						label: 'Present',
																				  }
																				: empAtt?.status ==
																				  'notMarked'
																				? {
																						value: 'notMarked',
																						label: 'Not Marked',
																				  }
																				: {
																						value: 'absent',
																						label: 'Absent',
																				  },
																			empAtt?.notes[0]
																				?.message,
																			empAtt?._id,
																		);
																	}
																}}
															>
																<td>
																	<p className="working-hr-text">
																		{moment(
																			empAtt?.date.toString(),
																			'YYYYMMDD',
																		).format('DD MMMM YYYY')}
																	</p>{' '}
																</td>

																<td>
																	<div
																		className="att-state-box"
																		style={{
																			backgroundColor:
																				empAtt?.status ==
																				'present'
																					? '#8FDCC4'
																					: !empAtt?.status
																					? '#F2C5BA'
																					: '#EAECF0',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{empAtt?.status
																			? empAtt?.status
																			: 'Absent'}
																	</div>
																</td>
																<td
																	style={{ position: 'relative' }}
																	// onMouseEnter={() =>
																	// 	this.handleMouseEnter(0)
																	// }
																	// onMouseLeave={() =>
																	// 	this.handleMouseLeave(0)
																	// }
																>
																	{' '}
																	<div
																		style={{
																			display: 'flex',

																			flexDirection: 'column',
																			gap: '12px',
																		}}
																	>
																		<p className="clock-in-out-text">
																			{empAtt?.logins
																				?.length > 0 &&
																				empAtt?.logins[0]?.timestamp.substring(
																					0,
																				)}
																		</p>

																		{empAtt?.logins?.length >
																			1 && (
																			<p className="clock-in-out-text">
																				{empAtt?.logins[1]?.timestamp.substring(
																					0,
																				)}
																				{empAtt?.logins
																					?.length > 2 ? (
																					<span>
																						{' + ' +
																							(empAtt
																								?.logins
																								?.length -
																								2)}
																					</span>
																				) : null}
																			</p>
																		)}
																	</div>
																	<div
																		style={{
																			position: 'absolute',
																			width: '236px',
																			height: '52px',
																			padding:
																				'8px 12px 8px 12px',
																			borderRadius: '8px',
																			border: '0 0 0.5px 0',
																			gap: '10px',
																			backgroundColor:
																				'#6055EC',
																			color: '#FFF',
																			fontFamily: 'Inter',
																			fontSize: '14px',
																			fontStyle: 'normal',
																			fontWeight: '400',
																			lineHeight: '18px',
																			letterSpacing:
																				'-0.28px',
																			display: this.state
																				.hoveredRows[0]
																				? 'flex'
																				: 'none',
																		}}
																	>
																		<Info />{' '}
																		<p>
																			{' '}
																			Your tooltip content
																			goes here
																		</p>
																	</div>
																</td>
																<td
																	style={{ position: 'relative' }}
																	// onMouseEnter={() =>
																	// 	this.handleMouseEnter2(0)
																	// }
																	// onMouseLeave={() =>
																	// 	this.handleMouseLeave2(0)
																	// }
																>
																	{' '}
																	<div
																		style={{
																			display: 'flex',

																			flexDirection: 'column',
																			gap: '12px',
																		}}
																	>
																		<p className="clock-in-out-text">
																			{empAtt?.logouts
																				?.length > 0 &&
																				empAtt?.logouts[0]?.timestamp.substring(
																					0,
																				)}
																		</p>
																		{empAtt?.logouts?.length >
																			1 && (
																			<p className="clock-in-out-text">
																				{empAtt?.logouts[1]?.timestamp.substring(
																					0,
																				)}
																				{empAtt?.logouts
																					?.length > 2 ? (
																					<span>
																						{' + ' +
																							(empAtt
																								?.logouts
																								?.length -
																								2)}
																					</span>
																				) : null}
																			</p>
																		)}
																	</div>
																	<div
																		style={{
																			position: 'absolute',
																			width: '236px',
																			height: '52px',
																			padding:
																				'8px 12px 8px 12px',
																			borderRadius: '8px',
																			border: '0 0 0.5px 0',
																			gap: '10px',
																			backgroundColor:
																				'#6055EC',
																			color: '#FFF',
																			fontFamily: 'Inter',
																			fontSize: '14px',
																			fontStyle: 'normal',
																			fontWeight: '400',
																			lineHeight: '18px',
																			letterSpacing:
																				'-0.28px',
																			display: this.state
																				.hoveredRows2[0]
																				? 'flex'
																				: 'none',
																		}}
																	>
																		<Info />{' '}
																		<p>
																			{' '}
																			Your tooltip2 content
																			goes here
																		</p>
																	</div>
																</td>
																<td>
																	<p className="brand-text">
																		{empAtt.totalHours &&
																			formatEmpAttHours(
																				empAtt.totalHours,
																			)}
																	</p>
																</td>
															</tr>
														);
													},
												)}
										</DataTableCompact>
									</div>

									{/*  */}
								</div>
							</div>
						</div>
					)}
				</div>
				{this.state.showEditAttendanceModal == true ? (
					<EditAttendance
						handleClose={() =>
							this.setState(
								{
									showEditAttendanceModal: false,
								},
								() => {
									this.fetchMoreAttDetailsList();
								},
							)
						}
						modalData={this.state.modalData}
						// assignedToOptions={this.state.assignedToOptions}
						show={this.state.showEditAttendanceModal}
						custClass={'modal-with-no-fixed-height'}
					/>
				) : null}
			</div>
		);
	}
}
export default withRouter(EmployeeAttendanceDetails);
